export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-6014HD_white-fd3bb964af7d37c20c2c516f701b2a8c.webp";